// PolyhouseConstruction.js
import React from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import FooterwithoutLogin from "../../Pages Without Login/controllEnvironmentPolyhouse/footerwithoutLogin";
import { FaAngleRight } from "react-icons/fa";
import { enquiryInfo } from "../../SchemaInfo/enquiryInfo";
import { enquirySchema } from "../../Schemas/Enquiry/enquiry_schema";
import { Formik, Form } from "formik";
import CustomInput from "../../CustomComponent/custom_input";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import { useState } from "react";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import LoadingPage from "../../Components/layouts/loading";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { BsBoxArrowInRight } from "react-icons/bs";
import { useEffect } from "react";

const PolyhouseConstruction = () => {
  const { state, city } = useParams();
  const [loading, setLoading] = useState(false);
  const [district, setDistrict] = useState([]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/subsidy/get-district/?state=${state}`)
      .then((res) => {
        if (res.status === 201) {
          const first15Districts = res.data
            .slice(0, 15)
            .map((d) => d.toLowerCase());

          setDistrict(first15Districts);
        } else {
          Toast("error", "Error while getting application!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [state]);

  const handelSubmit = (values, actions) => {
    values = { ...values, origin: "Polyhouse-Construction-Alpha" };

    // const formData = new FormData();

    // for (let key in values) {
    //   if (values[key] instanceof File || values[key] instanceof Blob) {
    //     formData.append(key, values[key]);
    //   } else if (typeof values[key] === "object" && values[key] !== null) {
    //     formData.append(key, JSON.stringify(values[key]));
    //   } else {
    //     formData.append(key, values[key]);
    //   }
    // }

    // const headers = { "content-type": "multipart/form-data" };
    setLoading(true);
    performRequest("POST", "/enquiryWebhook/createEnquiry/", values)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Enquiry Created Cuccessfully!");
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div>
      <Helmet>
        <title>
          Polyhouse Construction in {city}, {state}
        </title>
        <meta
          name="description"
          content={`Kryzen Biotech offers expert polyhouse construction services in ${city}, ${state}. Modern protected cultivation for higher yields and sustainable farming.`}
        />
        <meta
          name="keywords"
          content={`
      Polyhouse construction in ${city}, 
      Polyhouse construction in ${state}, 
      Polyhouse setup ${city}, 
      Polyhouse setup ${state}, 
      Greenhouse construction ${city}, 
      Greenhouse construction ${state}, 
      Naturally ventilated polyhouse ${city}, 
      Naturally ventilated polyhouse ${state}, 
      Climate controlled polyhouse ${city}, 
      Climate controlled polyhouse ${state}, 
      Protected cultivation polyhouse ${city}, 
      Protected cultivation polyhouse ${state}, 
      Modern farming polyhouse ${city}, 
      Modern farming polyhouse ${state}, 
      Kryzen Biotech polyhouse ${city}, 
      Kryzen Biotech polyhouse ${state}
    `}
        />
        <meta
          property="og:title"
          content={`Polyhouse Construction in ${city}, ${state}`}
        />
        <meta
          property="og:description"
          content={`Set up a modern polyhouse in ${city}, ${state}. We design and build naturally ventilated and climate-controlled polyhouses with end-to-end support.`}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`https://alpha.kryzen.com/polyhouse-farm-construction/${state}/${city}`}
        />
        <link
          rel="canonical"
          href={`https://alpha.kryzen.com/polyhouse-farm-construction/${state}/${city}`}
        />
      </Helmet>

      {/* <div className="container py-5">
        <h1
          className="text-center mb-4 fw-bold text-uppercase"
          style={{ fontSize: "35px" }}
        >
          Polyhouse Construction in {city}, {state}
        </h1>

        <hr />
        <div className="content">
          <p className="fs-2 lh-lg">
            Kryzen Biotech is a trusted name in{" "}
            <strong>Polyhouse Construction</strong>, helping farmers and
            entrepreneurs in {city}, {state} adopt{" "}
            <strong>protected cultivation technology</strong>. Our modern
            polyhouses provide a controlled environment that ensures{" "}
            <strong>
              higher yields, year-round production, and premium crop quality
            </strong>
            .
          </p>

          <p className="fs-2 lh-lg">
            We specialize in constructing{" "}
            <strong>
              naturally ventilated polyhouses, fan & pad systems, and
              climate-controlled structures
            </strong>{" "}
            that match the climatic conditions of {state}. With durable GI
            structures, UV-stabilized covering, and automated irrigation, our
            polyhouses guarantee{" "}
            <strong>efficiency, longevity, and profitability</strong>.
          </p>

          <p className="fs-2 lh-lg">
            In {city}, farmers are increasingly adopting polyhouses to grow{" "}
            <strong>
              capsicum, cucumber, tomato, strawberry, gerbera, roses, and exotic
              vegetables
            </strong>
            . With polyhouse farming,{" "}
            <strong>
              pesticide usage is reduced, crop cycles are longer, and
              productivity is 5–10 times higher
            </strong>{" "}
            compared to open-field farming.
          </p>

          <p className="fs-2 lh-lg">
            Our <strong>end-to-end services</strong> include{" "}
            <strong>
              site survey, design, material supply, construction, and training
            </strong>
            . Kryzen Biotech ensures your polyhouse project in {state} is built
            with the{" "}
            <strong>
              best structural stability, proper ventilation, and water
              management systems
            </strong>
            .
          </p>

          <p className="fs-2 lh-lg">
            We have successfully delivered{" "}
            <strong>polyhouse projects across India</strong>, enabling farmers
            in {state} to increase income through{" "}
            <strong>
              protected cultivation and government subsidy schemes
            </strong>
            .
          </p>

          <p className="fs-2 lh-lg">
            In conclusion,{" "}
            <strong>
              Polyhouse Construction in {city}, {state}
            </strong>{" "}
            is a smart investment for farmers and agripreneurs. With rising
            demand for high-quality vegetables, flowers, and fruits, polyhouses
            offer
            <strong>
              better control, higher profits, and sustainable farming
            </strong>
            . Kryzen Biotech is your reliable partner in building future-ready
            polyhouse farms.
          </p>
        </div>
        <div className="extra-content mt-5">
          <hr></hr>
          <h2 className="fw-bold text-primary mb-3">
            Why Choose Kryzen Biotech for Polyhouse Construction in {city},{" "}
            {state}?
          </h2>
          <hr></hr>
          <ul className="fs-2 lh-lg">
            <li>
              ✅ Customized designs to suit local climatic conditions in {state}
              .
            </li>
            <li>✅ High-quality GI pipes with rust-proof coatings.</li>
            <li>
              ✅ UV-stabilized poly films ensuring durability and light
              transmission.
            </li>
            <li>✅ Automated irrigation and fertigation systems.</li>
            <li>
              ✅ Assistance in availing{" "}
              <strong>government subsidies for polyhouse farming</strong>.
            </li>
            <li>
              ✅ Complete training & handholding for farmers and investors.
            </li>
          </ul>
          <hr></hr>
          <h2 className="fw-bold text-primary mt-5 mb-3">
            Benefits of Polyhouse Farming in {city}, {state}
          </h2>
          <hr></hr>
          <p className="fs-2 lh-lg">
            By choosing polyhouse construction in {city}, {state}, farmers can{" "}
            <strong>increase their productivity by 5–10 times</strong>,
            cultivate <strong>off-season crops</strong>, and significantly{" "}
            <strong>reduce pesticide usage</strong>. It also helps in{" "}
            <strong>
              water conservation, better disease management, and year-round
              cultivation
            </strong>
            .
          </p>
        </div>
        <div className="d-flex justify-content-start align-items-center mb-2">
          <button
            className="btn btn-sm px-3 btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#modal-seo"
            // style={{
            //   width: "80px",
            //   height: "25px",
            // }}
          >
            <FaAngleRight className="fs-2"></FaAngleRight>&nbsp;{" "}
            <span className="fs-2">ENQUIRY</span>
          </button>
        </div>
      </div>
      <div
        className="modal modal-blur fade"
        id="modal-seo"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <Formik
          initialValues={enquiryInfo}
          validationSchema={enquirySchema}
          onSubmit={handelSubmit}
          enableReinitialize
        >
          {(props) => (
            <Form className="modal-dialog modal-dialog-centered w-lg-100 w-md-100">
              <div className="modal-dialog modal-dialog-centered w-100">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Add Enquiry</h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="mb-3">
                      <label className="form-label">First Name</label>
                      <CustomInput name="firstName" type="text" />
                      {props.touched.firstName && props.errors.firstName && (
                        <p className="text-danger">{props.errors.firstName}</p>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Last Name</label>
                      <CustomInput name="lastName" type="text" />
                      {props.touched.lastName && props.errors.lastName && (
                        <p className="text-danger">{props.errors.lastName}</p>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label required">Full Name</label>
                      <CustomInput name="fullName" type="text" />
                      {props.touched.lastName && props.errors.fullName && (
                        <p className="text-danger">{props.errors.fullName}</p>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label required">
                        Mobile Number
                      </label>
                      <CustomInput name="mobileNumber" type="text" />
                      {props.touched.mobileNumber &&
                        props.errors.mobileNumber && (
                          <p className="text-danger">
                            {props.errors.mobileNumber}
                          </p>
                        )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label required">Email</label>
                      <CustomInput name="email" type="text" />
                      {props.touched.email && props.errors.email && (
                        <p className="text-danger">{props.errors.email}</p>
                      )}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <FormSubmitButton
                      isSubmitting={props.isSubmitting}
                      buttonText="Submit"
                      data-bs-dismiss="modal"
                    />
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div> */}
      <div className="px-3 px-md-8 ms-md-8 me-md-8  py-4">
        <h1
          className="text-center fw-bold text-uppercase"
          style={{ fontSize: "2.2rem" }}
        >
          Polyhouse Construction in {city}, {state}!
        </h1>
        <hr></hr>
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="p-1 p-md-2">
              {/* Content Section */}
              <div className="">
                <h2 className="lh-lg fs-1 text-center">
                  Kryzen Biotech is a trusted name in{" "}
                  <strong>Polyhouse Construction</strong>, helping farmers and
                  entrepreneurs in {city}, {state} adopt{" "}
                  <strong>protected cultivation technology</strong>. Our modern
                  polyhouses provide a controlled environment that ensures{" "}
                  <strong>
                    higher yields, year-round production, and premium crop
                    quality
                  </strong>
                </h2>
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755854071/hydroponic_2_kadelx.jpg"
                  alt="middle img"
                  className="w-100 my-3"
                />
                <p className="fs-2 lh-lg mt-5">
                  {" "}
                  We specialize in constructing{" "}
                  <strong>
                    naturally ventilated polyhouses, fan & pad systems, and
                    climate-controlled structures
                  </strong>{" "}
                  that match the climatic conditions of {state}. With durable GI
                  structures, UV-stabilized covering, and automated irrigation,
                  our polyhouses guarantee{" "}
                  <strong>efficiency, longevity, and profitability</strong>.
                </p>{" "}
                <p className="fs-2 lh-lg">
                  In {city}, farmers are increasingly adopting polyhouses to
                  grow{" "}
                  <strong>
                    capsicum, cucumber, tomato, strawberry, gerbera, roses, and
                    exotic vegetables
                  </strong>
                  . With polyhouse farming,{" "}
                  <strong>
                    pesticide usage is reduced, crop cycles are longer, and
                    productivity is 5–10 times higher
                  </strong>{" "}
                  compared to open-field farming.
                </p>
                <p className="fs-2 lh-lg">
                  Our <strong>end-to-end services</strong> include{" "}
                  <strong>
                    site survey, design, material supply, construction, and
                    training
                  </strong>
                  . Kryzen Biotech ensures your polyhouse project in {state} is
                  built with the{" "}
                  <strong>
                    best structural stability, proper ventilation, and water
                    management systems
                  </strong>
                  .
                </p>
                <p className="fs-2 lh-lg">
                  We have successfully delivered{" "}
                  <strong>polyhouse projects across India</strong>, enabling
                  farmers in {state} to increase income through{" "}
                  <strong>
                    protected cultivation and government subsidy schemes
                  </strong>
                  .
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-4 mt-4 mt-md-5 p-3 border d-flex flex-column  align-items-center">
            {/* Form Section */}
            <div>
              <Formik
                initialValues={enquiryInfo}
                validationSchema={enquirySchema}
                onSubmit={handelSubmit}
                enableReinitialize
              >
                {(props) => (
                  <Form
                    className="card p-3 p-md-5 bg-green-lt"
                    // style={{ backgroundColor: "lightgreen" }}
                  >
                    <h2
                      className="fs-2 fs-md-3 text-center mb-3"
                      style={{ color: "black" }}
                    >
                      Join an expert call for polyhouse construction in {city},{" "}
                      {state}
                    </h2>
                    <hr></hr>
                    <div className="mb-3">
                      <label
                        className="form-label required"
                        style={{ color: "black" }}
                      >
                        First Name
                      </label>
                      <CustomInput name="firstName" type="text" />
                      {props.touched.firstName && props.errors.firstName && (
                        <p className="text-danger">{props.errors.firstName}</p>
                      )}
                    </div>

                    <div className="mb-3">
                      <label
                        className="form-label required"
                        style={{ color: "black" }}
                      >
                        Last Name
                      </label>
                      <CustomInput name="lastName" type="text" />
                      {props.touched.lastName && props.errors.lastName && (
                        <p className="text-danger">{props.errors.lastName}</p>
                      )}
                    </div>

                    {/* <div className="mb-3">
                      <label
                        className="form-label required"
                        style={{ color: "black" }}
                      >
                        Full Name
                      </label>
                      <CustomInput name="fullName" type="text" />
                      {props.touched.fullName && props.errors.fullName && (
                        <p className="text-danger">{props.errors.fullName}</p>
                      )}
                    </div> */}

                    <div className="mb-3">
                      <label
                        className="form-label required"
                        style={{ color: "black" }}
                      >
                        Mobile Number
                      </label>
                      <CustomInput name="mobileNumber" type="text" />
                      {props.touched.mobileNumber &&
                        props.errors.mobileNumber && (
                          <p className="text-danger">
                            {props.errors.mobileNumber}
                          </p>
                        )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label" style={{ color: "black" }}>
                        Email
                      </label>
                      <CustomInput name="email" type="text" />
                      {props.touched.email && props.errors.email && (
                        <p className="text-danger">{props.errors.email}</p>
                      )}
                    </div>

                    <div className="text-center mt-3">
                      {/* <FormSubmitButton buttonText="Submit" /> */}
                      <button
                        class="btn btn-github  btn mx-1 mt-2 text-center"
                        isSubmitting={props.isSubmitting}
                      >
                        <BsBoxArrowInRight className="fs-2 me-2"></BsBoxArrowInRight>
                        Submit
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
            <div className="mt-3">
              <img
                className="w-100"
                style={{ height: "600px" }}
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844954/sidebar_id3qyb.jpg"
                alt="conditions img"
              />
            </div>
          </div>
        </div>

        {/* Conditions Section */}
        <div className="row mt-7">
          <div className="col-12 col-md-4 mt-4 mt-md-0 d-flex justify-content-center align-items-center">
            <img
              className="card"
              style={{ height: "500px", width: "350px" }}
              src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844954/why_choose_kryzen_uf7slk.jpg"
              alt="why choose kryzen img"
            />
          </div>
          <div className="col-12 col-md-8 ps-md-2 ">
            <h2 className="fw-bold text-uppercase mb-3 fs-1 mt-5 mt-md-0 mt-lg-0">
              Why Choose Kryzen Biotech for Polyhouse Construction in {city},{" "}
              {state}?
            </h2>
            <hr />
            <p className="mt-4 fs-2 lh-lg">
              <b>Kryzen Biotech</b> is a leading polyhouse construction company
              in Pune, Maharashtra, offering end-to-end solutions for modern
              protected farming. From robust structural designs with
              high-quality materials to automation in irrigation and
              fertigation, Kryzen Biotech ensures long-lasting and efficient
              polyhouses. With expert guidance on government subsidies,
              training, and agronomy support, we help farmers and agri-investors
              build sustainable businesses and achieve higher profitability in
              protected cultivation.
            </p>
            <ol className="fs-2 lh-lg ">
              <li>
                Customized designs to suit local climatic conditions in {state}.
              </li>
              <li> High-quality GI pipes with rust-proof coatings.</li>
              <li>
                UV-stabilized poly films ensuring durability and light
                transmission.
              </li>
              <li> Automated irrigation and fertigation systems.</li>
              <li>
                Assistance in availing{" "}
                <strong>government subsidies for polyhouse farming</strong>.
              </li>
              <li>
                Complete training & handholding for farmers and investors.
              </li>
            </ol>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="row mt-7">
          <div className="col-12 col-md-8">
            <h2 className="fw-bold mb-3 text-uppercase fs-1">Benefits</h2>
            <hr />
            <p className="mt-4 fs-2 lh-lg">
              <b>Polyhouse farming in {city}</b>, {state}, empowers farmers with
              controlled environmental conditions that boost crop yields,
              improve quality, and reduce input costs. By enabling off-season
              cultivation and lowering pesticide dependency, polyhouses ensure
              safer produce and higher market value. With advanced structures
              and scientific management, Kryzen Biotech helps farmers achieve
              sustainable growth and profitability through modern protected
              farming solutions.
            </p>
            <ol className="fs-2 lh-lg">
              <li>
                By choosing polyhouse construction in {city}, {state}, farmers
                can
                <strong> increase their productivity by 5–10 times</strong>.
              </li>
              <li>
                Cultivate <strong>off-season crops</strong>.
              </li>
              <li>
                Significantly <strong>reduce pesticide usage</strong>.
              </li>
              <li>
                Support <strong>water conservation</strong>.
              </li>
              <li>
                Achieve <strong>better disease management</strong>.
              </li>
              <li>
                Ensure <strong>year-round cultivation</strong>.
              </li>
            </ol>
          </div>
          <div className="col-12 col-md-4 mt-4 mt-md-0 d-flex justify-content-center align-items-center">
            <img
              className="card"
              style={{ height: "500px", width: "350px" }}
              src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844954/benifits_v6xubk.jpg"
              alt="benefits img"
            />
          </div>
        </div>
        {/* <hr></hr> */}
        <hr></hr>
        <div className="row mt-7">
          {/* Image Section */}
          <div className="col-12 col-md-5 mt-4 mt-md-0 d-flex justify-content-center align-items-center mb-4 mb-md-0">
            <img
              className="card img-fluid"
              style={{ maxHeight: "500px", width: "100%", objectFit: "cover" }}
              src="https://res.cloudinary.com/bsgfcooa/image/upload/v1756358719/shark_tank_uvzuuq.jpg"
              alt="Shark Tank"
            />
          </div>

          {/* Text Section */}
          <div className="col-12 col-md-6 ps-md-2 ms-md-5  text-md-start">
            <h1 className="fw-bold text-uppercase mb-3 fs-1 mt-3 mt-md-0">
              We build best protected farming technology for the world!
            </h1>
            <hr className="mx-auto mx-md-0" />
            <p className="mt-4 fs-2 lh-lg">
              Build a commercially profitable farm anywhere and earn up to
              ₹1,25,000 per month from just 5000 sqft.
            </p>
            <p className="mt-4 fs-2 lh-lg">
              We are top turnkey commercial hydroponics farm project development
              company. We set up hydroponic farms that are low in capex and high
              in returns on investment. With fastest ROI mechanism, We develop
              farm that generates good returns in lowest possible time.
            </p>
          </div>
        </div>
        <div className="row mt-5">
          <h3 className="fs-1 pb-3 text-uppercase">Conclusion</h3>
          <hr></hr>
          <p className="fs-2">
            In conclusion,{" "}
            <strong>
              Polyhouse Construction in {city}, {state}
            </strong>{" "}
            is a smart investment for farmers and agripreneurs. With rising
            demand for high-quality vegetables, flowers, and fruits, polyhouses
            offer
            <strong>
              better control, higher profits, and sustainable farming
            </strong>
            . Kryzen Biotech is your reliable partner in building future-ready
            polyhouse farms.
          </p>
        </div>
        <div className="row mt-7">
          <div className="row">
            <h2 className="fw-bold text-uppercase mb-3 fs-1">
              Explore Polyhouse Construction in Other Cities of {state}
            </h2>
            <hr />

            {district.slice(0, 15).map((city, index) => (
              <div key={index} className="col-12 col-md-4 col-lg-4">
                <ul className="fs-3 lh-lg">
                  <li>
                    <a
                      href={`/polyhouse-farm-construction/${state}/${city.toLowerCase()}`}
                      className="text-decoration-none text-success"
                    >
                      Polyhouse Construction in {city}, {state}
                    </a>
                  </li>
                </ul>
              </div>
            ))}
          </div>
        </div>
        <hr></hr>
        <div className="row">
          <div className="col-12">
            <img
              className="w-100"
              // style={{height:"380px"}}
              src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844969/footer_jclvvn.jpg"
              alt="footer img"
            ></img>
          </div>
        </div>
      </div>
      <FooterwithoutLogin />
    </div>
  );
};

export default PolyhouseConstruction;
